export const TEST_ID = 'airworthyMenu';
